<!--CFS > Consolidation Collection-->
<template>
  <a-drawer title="Consolidation Collection" @close="onClose" :visible="showDrawer" width="95%" :maskClosable="false">
    <a-row type="flex" justify="start" style="margin-top: 30px;">
      <a-col span="10" offset="1" style="border: 0px solid red;">
        <el-form ref="form" :model="formData" label-width="150px">
          <el-form-item :label="$t('cfs.orderNumber')+':'" style="font-weight: bold;">
            {{$t(formData.orderNumber)}}
          </el-form-item>
          <el-form-item :label="$t('cfs.barcode')+':'">
            <el-input ref="barcodeRef" :placeholder="$t('publicLang.PleaseEnter')" v-model="formData.barCode" maxlength="100" @keyup.enter.native="scanBarcode" :readonly="formData.orderNumber.length>0" clearable></el-input>
          </el-form-item>
          <a-row>
            <a-col span="15">
              <el-form-item :label="$t('pubGicSet.Weight')+':'">
                <el-input ref="weightRef" :placeholder="$t('publicLang.PleaseEnter')" v-model="formData.weight" maxlength="10" @keyup.enter.native="enterNext('length')" onkeyup ="value=value.replace(/[^0-9.]/g,'')" clearable></el-input>
              </el-form-item>
            </a-col>
            <a-col span="2">
              <el-form-item :label="weightUom"></el-form-item>
            </a-col>
            <a-col style="margin-top:10px;float: right;">
              <el-checkbox v-model="damageCheck" style="font-weight: bold">{{$t('cfs.damage')}}</el-checkbox>
            </a-col>
          </a-row>
          <a-row>
            <el-form-item :label="$t('cfs.dimensions')+'('+dimUom+')'+':'" style="text-align: center;">
              <a-col span="7">
                <el-input ref="lengthRef" placeholder="L" v-model="formData.length" maxlength="5" @keyup.enter.native="enterNext('width')" onkeyup="value=value.replace(/[^\d]/g,'')" clearable></el-input>
              </a-col>
              <a-col span="1">X</a-col>
              <a-col span="7">
                <el-input ref="widthRef" placeholder="W" v-model="formData.width" maxlength="5" @keyup.enter.native="enterNext('height')" onkeyup="value=value.replace(/[^\d]/g,'')" clearable></el-input>
              </a-col>
              <a-col span="1">X</a-col>
              <a-col span="8">
                <el-input ref="heightRef" placeholder="H" v-model="formData.height" maxlength="5" onkeyup="value=value.replace(/[^\d]/g,'')" clearable></el-input>
              </a-col>
            </el-form-item>
          </a-row>
          <a-row style="float: right;">
              <el-button type="primary" size="small" @click="reset">{{$t('cfs.nextOrder')}}</el-button>
              <el-button v-if="formData.allowSave" style="margin-left: 45px;" type="success" size="small" @click="saveData">{{$t('userlang.Save')}}</el-button>
          </a-row>
        </el-form>
      </a-col>
      <a-col span="10" offset="1" style="margin-top: 40px;">
        <a-row style="font-weight: bold;">
          <a-col span="10" style="margin-top: 20px;color: #606266;">{{$t('pubGicSet.Location')}}:</a-col>
          <el-button v-if="formData.received" type="danger" style="float: right;background-color: red;cursor: auto;"><span style="font-size: 30px;font-weight: bold;">{{$t('batchReceive.Received')}}</span></el-button>
        </a-row>
        <a-row>
          <el-card class="box-card" style="margin-top: 10px;height: 210px;text-align: center;font-size: 110px;font-weight: bold;color: grey;">
            {{$t(formData.location)}}
          </el-card>
        </a-row>
      </a-col>
    </a-row>
  </a-drawer>
</template>
<script>
  import ajax from "../../../api/ajax";
  import api from "../../../api/url";
  import { mapState } from "vuex";
  import Template from "../reportCom/template";
  export default {
    components: {Template},
    data() {
      return {
        showDrawer:false,//显示抽屉
        barCode:'',
        weightUom:'kg',
        dimUom:'cm',
        damageCheck:false,
        formData: {
          barCode: '',
          orderNumber:'',
          weight:'',
          damage:'',
          length:'',
          width:'',
          height:'',
          location:'',
          clear:false,
          received:false,
          allowSave:false,
          jump:false,
        },
        CONSOLIDATIONHANDLING:'ORIGIN',//获取系统参数值
      }
    },
	     computed: {
             ...mapState(["systemParam"]),
        },
    methods: {
      //关闭抽屉
      onClose() {
        this.showDrawer = false;
        this.reset();
      },
      //重置
      reset(){
        this.formData= {
          barCode: '',
          orderNumber:'',
          weight:'',
          damage:'',
          length:'',
          width:'',
          height:'',
          location:'',
          clear:false,
          received:false,
          allowSave:false,
          jump:false,
        }
        this.damageCheck = false
        this.$refs.barcodeRef.focus();
      },
      //打开弹窗
      show(id,type) {
        this.showDrawer = true;
        this.getUom();
        this.CONSOLIDATIONHANDLING = this.systemParam.CONSOLIDATION_HANDLING;
        this.$nextTick(function () {
          this.$refs.barcodeRef.focus();
        });
      },
      getUom(){
        ajax.post(api.CONSOLIDATIONGETUOM).then(res=>{
          if(res.code == 200){
            this.dimUom = res.data.dimUom
            this.weightUom = res.data.weightUom
          }
        })
      },
      enterNext(val) {
        if(val=='length'){
          this.$refs.lengthRef.focus();
          this.$refs.lengthRef.select()
        }else if(val=='width'){
          this.$refs.widthRef.focus();
          this.$refs.widthRef.select()
        }else if(val=='height'){
          this.$refs.heightRef.focus();
          this.$refs.heightRef.select()
        }

      },
      scanBarcode() {
        if(this.formData.barCode == null || this.formData.barCode == ''){
          this.$customMessage.warning(this.$t('cfs.barcode') +" "+ this.$t('job.notNull'),2);
          return;
        }
        let params = {
          barcode: this.formData.barCode,
          orderNumber:this.formData.orderNumber
        };
        ajax.post(api.CONSOLIDATIONSCANBARCODE,params).then(res=>{
          if(res.code == 200){
            this.formData = res.data
            this.damageCheck = this.formData.damage == 'DAMAGE' ? true : false
            if(!this.formData.clear){
              this.formData.barCode = res.data.barcode;
            }
            if(this.formData.jump){
              this.$refs.weightRef.focus();
              this.$refs.weightRef.select()
            }
          }else{
            this.reset()
            this.$customMessage.warning(res.msg);
          }
        })
      },
      saveData() {
        if(this.formData.orderNumber == null || this.formData.orderNumber == ''){
          this.$customMessage.warning(this.$t('cfs.orderNumber') +" "+ this.$t('job.notNull'),2);
          return;
        }
        if(this.formData.location == null || this.formData.location == ''){
          this.$customMessage.warning(this.$t('pubGicSet.Location') +" "+ this.$t('job.notNull'),2);
          return;
        }
        this.formData.weight = this.formData.weight.replace(/[^0-9.]/g,'')
        this.formData.length = this.formData.length.replace(/[^\d]/g,'')
        this.formData.width = this.formData.width.replace(/[^\d]/g,'')
        this.formData.height = this.formData.height.replace(/[^\d]/g,'')
        if(this.CONSOLIDATIONHANDLING=='' || this.CONSOLIDATIONHANDLING=='ORIGIN'){
          if(this.formData.weight == 0 || this.formData.weight == ''){
            this.$customMessage.warning(this.$t('pubGicSet.Weight') +" "+ this.$t('job.notNull'),2);
            return;
          }
          if(this.formData.length == 0 || this.formData.length == ''){
            this.$customMessage.warning(this.$t('pubGicSet.Length') +" "+ this.$t('job.notNull'),2);
            return;
          }
          if(this.formData.width == 0 || this.formData.width == ''){
            this.$customMessage.warning(this.$t('pubGicSet.Width') +" "+ this.$t('job.notNull'),2);
            return;
          }
          if(this.formData.height == 0 || this.formData.height == ''){
            this.$customMessage.warning(this.$t('pubGicSet.Height') +" "+ this.$t('job.notNull'),2);
            return;
          }
        }
        let params = {
          orderNumber:this.formData.orderNumber,
          barcode: this.formData.barCode,
          location: this.formData.location,
          weight: this.formData.weight,
          length: this.formData.length,
          width: this.formData.width,
          height: this.formData.height,
          damage: this.damageCheck == true ? 'DAMAGE' : '',
          dimUom: this.dimUom,
          weightUom: this.weightUom,
        };
        ajax.post(api.CONSOLIDATIONSAVEDATA,params).then(res=>{
          if(res.code == 200){
            this.$message.success(this.$t('pubGicSet.SaveSuccess'));
            this.reset();
          }else{
            this.$customMessage.warning(res.msg);
          }
        })
      },
    }
  };
</script>
<style lang="less">

</style>